module.exports = __webpack_public_path__ + "static/media/celestefarewell.534c3e8a.png";